const navComponent = () => {
	
	// Remove click from no-click links
	const $noClickLinks = $('.no-click > a');
	$noClickLinks.attr('href', 'javascript:void(0)');
	
	// Toggle menu
	const $menuButton = $('.menu-button');
	
	$menuButton.on('click', function() {
		$body.toggleClass('menu-open');
		if ( $body.hasClass('menu-open') ) {
			lenis.stop();
		} else {
			lenis.start();
			closeAll();
		}
	});
	
	const MENU_OPEN_CLASS    = 'main-menu--open';
	const MEGA_ACTIVE_CLASS  = 'mega-menu--active';
	const TOP_ITEM_SELECTOR  = 'ul.main-menu > li.has-mega-menu';
	const MEGA_MENU_SELECTOR = '.mega-menu';
	const CLOSE_BTN_SELECTOR = '.mega-menu__close';

	// Stored so we can cleanly remove listeners on resize to desktop
	const clickHandlers = new Map();
	const closeHandlers = new Map();

	// -------------------------------------------------------------------------
	// Core helpers
	// -------------------------------------------------------------------------

	/**
	* Close all open mega menus and remove the open class from the root ul.
	*/
	function closeAll() {
		const menu = document.querySelector( 'ul.main-menu' );
		if ( menu ) {
			menu.classList.remove( MENU_OPEN_CLASS );
		}

		document.querySelectorAll( TOP_ITEM_SELECTOR ).forEach( ( li ) => {
			const mega = li.querySelector( MEGA_MENU_SELECTOR );
			if ( mega ) {
				mega.classList.remove( MEGA_ACTIVE_CLASS );
			}
		} );
	}

	/**
	* Handle a click on a top-level LI.
	* Closes any currently open mega menu, then opens the one under this LI.
	*
	* @param {HTMLElement} li  The top-level <li> element.
	*/
	function handleTopLevelClick( li ) {
		const mega = li.querySelector( MEGA_MENU_SELECTOR );
		if ( ! mega ) return;

		const menu = document.querySelector( 'ul.main-menu' );

		// Close any currently open item first
		closeAll();

		// Open this one
		if ( menu ) {
			menu.classList.add( MENU_OPEN_CLASS );
		}
		mega.classList.add( MEGA_ACTIVE_CLASS );
	}

	/**
	* Bind click handlers to all .mega-menu__close buttons.
	*/
	function bindCloseButtons() {
		document.querySelectorAll( CLOSE_BTN_SELECTOR ).forEach( ( btn ) => {
			if ( closeHandlers.has( btn ) ) return; // Avoid double-binding
			
			const handler = ( e ) => {
				e.stopPropagation();
				closeAll();
			};
			closeHandlers.set( btn, handler );
			btn.addEventListener( 'click', handler );
		} );
	}

	/**
	* Remove click handlers from all .mega-menu__close buttons.
	*/
	function unbindCloseButtons() {
		closeHandlers.forEach( ( handler, btn ) => {
			btn.removeEventListener( 'click', handler );
		} );
		closeHandlers.clear();
	}

	/**
	* Bind click handlers to all top-level LIs.
	*/
	function bindMobileClicks() {
		document.querySelectorAll( TOP_ITEM_SELECTOR ).forEach( ( li ) => {
			if ( clickHandlers.has( li ) ) return; // Avoid double-binding

			const handler = () => handleTopLevelClick( li );
			clickHandlers.set( li, handler );
			li.addEventListener( 'click', handler );
		} );

		bindCloseButtons();
	}

	/**
	* Remove click handlers from all top-level LIs and reset all open states.
	*/
	function unbindMobileClicks() {
		clickHandlers.forEach( ( handler, li ) => {
			li.removeEventListener( 'click', handler );
		} );
		clickHandlers.clear();
		unbindCloseButtons();
		closeAll();
	}

	// -------------------------------------------------------------------------
	// GSAP MatchMedia
	// -------------------------------------------------------------------------

	const mm = gsap.matchMedia();

	mm.add(
		{
			mobile:  '(max-width: 1023px)',
			desktop: '(min-width: 1024px)',
		},
		( context ) => {
			const { mobile } = context.conditions;

			if ( mobile ) {
				bindMobileClicks();
			} else {
				unbindMobileClicks();
			}

			// Cleanup runs automatically when conditions change
			return () => {
				unbindMobileClicks();
			};
		}
	);
	
}

export {
	navComponent
};